import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

import { generateFetchLatestMoviesRequestObj } from './fetchLatestMoviesHandler';
import { ConsumptionPageTypes } from '../../../types/consumption';
import { FETCH_LATEST_MOVIES_DATA_QUERY } from '../../GraphQL/Queries/LatestMovies';
import { graphQlRequest } from '../../GraphQL/RequestHandler';

export const fetchLatestMovies = async (
  translation = 'en',
  languages = 'en,hi,mr,te',
  country = 'IN',
  genres?: string[]
): Promise<ConsumptionPageTypes.FilterMoviesResponse | any> => {
  try {
    const response: any = await graphQlRequest(
      FETCH_LATEST_MOVIES_DATA_QUERY,
      generateFetchLatestMoviesRequestObj(
        translation,
        languages,
        country,
        genres
      ),
      GQL_QUERIES.FETCH_LATEST_MOVIES_DATA_QUERY
    );
    return response?.movies?.contents || {};
  } catch (error) {
    console.error('Error while fetching latest movies: ', error);
    return {};
  }
};
